exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".embed-coach-table-title {\n  font-family: 'Oswald', Arial, sans-serif !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/features/director/pages/dashboard/components/embed-coach-table/EmbedCoachTable.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/features/director/pages/dashboard/components/embed-coach-table/EmbedCoachTable.css
// module chunks = 2